<script setup lang="ts">
import UiModal from '@boats/ui/components/UiModal.vue'

const modals = useModalsStore()
</script>

<template>
  <UiModal
    v-model="modals.isRegisterModalOpen"
    mobile-full-screen
    class="app-modal-register"
    @close="modals.closeRegisterModal"
  >
    <h2 class="h1 mb-2">{{ $t('modal.register.title') }}</h2>

    <p class="mb-5 md:mb-8">
      {{ $t('modal.register.login.text') }}
      <a
        role="button"
        @click="
          () => {
            modals.openLoginModal()
            modals.closeRegisterModal()
          }
        "
      >
        {{ $t('string.Login') }}
      </a>
    </p>

    <AppFormRegister />
  </UiModal>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-modal-register {
  .ui-modal__content {
    text-align: center;

    @include media-breakpoint-up(md) {
      h2 {
        font-size: 2.625rem;
        font-weight: 400;
        line-height: 1;
      }
    }
  }
}
</style>
